<template>
  <loading-notification
    v-if="dossiers.length === 0"
    message="De kwalificatiedossiers worden geladen...">
  </loading-notification>

  <div v-else>
    <div class="columns">
      <div class="column">
        <create-button
          caption="Nieuw dossier"
          @click="toggleUploader"
        ></create-button>
      </div>
    </div>

    <nav class="panel">
      <p class="panel-heading">Kwalificatiedossiers</p>

      <div class="panel-block">
        <p class="control has-icons-left">
          <input class="input" type="text" placeholder="Zoeken" v-model="query">
          <span class="icon is-small is-left">
          <i class="fas fa-search" aria-hidden="true"></i>
        </span>
        </p>
      </div>

      <router-link
          v-for="dossier in myDossiers"
          :key="dossier.nr"
          :to="{ name: inAdmin ? 'edit-dossier' : 'dossier', params: { 'nr': dossier.nr } }"
          class="panel-block">

      <span class="panel-icon" :class="{ 'is-hidden': dossier.hide }">
        <i class="fas fa-briefcase"></i>
      </span>

        {{ dossier.nr }} - {{ dossier.titel }} ({{ dossier.crebos | parsedCrebos }} {{ dossier.crebos | parsedDates }}) <span v-show="isPreceded(dossier.nrvoorganger)" class="tag preceded-by is-dark">nummer voorganger {{ dossier.nrvoorganger }}</span>
      </router-link>

    </nav>

    <upload-dossier
      :is-active="showUploader"
      @close="toggleUploader"
    ></upload-dossier>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import { authMixin } from '@/mixins'
import CreateButton from '@/components/modules/CreateButton'
import UploadDossier from '@/components/dossiers/UploadDossier'
import LoadingNotification from '@/components/modules/LoadingNotification'

export default {
  name: 'Bundles',

  beforeRouteEnter (to, from, next) {
    store.dispatch('dossiers/loadAll').then(next)
  },

  mixins: [
    authMixin
  ],

  filters: {
    parsedCrebos (crebos) {
      return crebos.map(crebo => crebo.nr).join(', ')
    },

    parsedDates (crebos) {
      return crebos.map(crebo => crebo.valid_from).join(', ')
    }
  },

  components: {
    CreateButton,
    UploadDossier,
    LoadingNotification
  },

  computed: {
    ...mapGetters({
      account: 'account/account',
      bundles: 'bundles/bundles',
      dossiers: 'dossiers/dossiers',
      visibleDossiers: 'dossiers/visibleDossiers'
    }),

    inAdmin () {
      return this.$route.name === 'list-dossiers'
    },

    accessibleDossiers () {
      return this.dossiers.filter((dossier) => {
        return this.isAdmin(this.account) || this.hasAccess(dossier.nr)
      })
    },

    myDossiers () {
      return this.accessibleDossiers.filter((x) => {
        return x.titel.toLowerCase().includes(this.query.toLowerCase()) ||
          x.nr.includes(this.query)
      })
    }
  },

  data () {
    return {
      query: '',
      showUploader: false
    }
  },

  methods: {
    isPreceded (nrVoorganger) {
      return nrVoorganger.length > 0
    },

    hasAccess (dossierNr) {
      return this.bundles.map(x => x.dossier_nr).includes(parseInt(dossierNr))
    },

    toggleUploader () {
      this.showUploader = !this.showUploader
    }
  }
}
</script>

<style scoped>
  .preceded-by {
    margin-left: 15px;
  }
</style>
